export function pushPageView() {
  const pageView = {
    event: "page view",
    environment: {
      isProduction: false,
      dataSource: "web",
      platform: {
        name: "BNA Test Site Lab",
        version: "d4c57b45d5c0a0c29fb2688377a5356d",
      },
    },
    org: {
      businessUnit: "Bonnier News Core Tracking",
      brandLine: "BNA Test Site",
      brand: "BNA Test Site",
      subBrand: "BNA Test Site",
      service: "main content",
      market: "se",
    },
    device: {
      screen: {
        width: window.screen.width,
        height: window.screen.height,
      },
      category: "desktop",
      os: {},
    },
    browser: {
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
      },
    },
    content: {
      location: window.location.href,
      referrer: document.referrer,
      section: [],
      id: {},
      title: document.title,
      type: "start",
      trigger: "page load",
      pageNotFound: false,
      isEmbedded: false,
      renderedSize: "desktop",
    },
    user: {
      isLoggedIn: true,
      id: {
        value: "77777777-7777-7777-7777-777777777777",
        system: "credentials",
      },
      isSubscriber: true,
    },
  };

  window.dataLayer.push(pageView);
}
